/**
 * AddTransactionReportCtrl controller
 *
 */
import moment from 'moment'
import * as _ from 'lodash-es'
import {
  PAYMENT_SYSTEM_TYPE_NAME,
  PAYMENT_SYSTEM_TYPES, REPORT_FIELDS,
  REPORT_FINANCIAL_PERIODS
} from '../../app/core/constants'
import { ascBy, has, lowerCaseProperty } from '../../app/helpers/object'
import { getFilteredKeys, multiSelectWithAll } from '../common/directives/contentItems/ciHelpers'

/* @ngInject */

export default function AddTransactionReportCtrl (
  $scope,
  $location,
  ReportTransactionSeed,
  ReportFinancialSeed,
  authSvc,
  alertLiteSvc,
  commonData,
  extra,
  scope
) {
  const vm = this
  vm.extra = extra
  vm.multiSelectWithAll = multiSelectWithAll
  vm.getFilteredKeys = getFilteredKeys
  vm.payment_system_types = PAYMENT_SYSTEM_TYPES
  vm.reportDates = REPORT_FINANCIAL_PERIODS
  vm.paymentSystemTypeName = PAYMENT_SYSTEM_TYPE_NAME
  vm.reportFields = REPORT_FIELDS

  vm.users_reporting_url = {
    ACTIVATIONS: 'activations'
  }
  vm.subscriptionsFilter = []
  vm.paymentMethodTypes = []
  vm.report = new ReportTransactionSeed()

  /**
   * Report reportPeriod default value
   *
   * @memberof mwApp/reports.controller:AddTransactionReportCtrl
   * @type {String}
   */
  vm.reportPeriod = '2DAYS'

  /**
   * Organizations select model
   *
   * @memberof mwApp/reports.controller:AddTransactionReportCtrl
   * @type {Object}
   */
  vm.organizationsSelect = {}

  vm.searchUsersParams = {
    searchStr: '',
    networkIds: [],
    page: 0,
    totalPages: 0
  }

  vm.submit = function () {
    vm.setDisable()
    vm.report
      ._save(() => {}, 'api/report/transactional/template')
      .then(function (response) {
        $location.hash('reports_list')

        commonData.data.update('lastTemplate', has('payload')(response.data)
          ? response.data.payload.id
          : response.data.id)

        vm.location.reload()
      })
      .finally(vm.unsetDisable)
  }

  ReportFinancialSeed.load(`api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/extra/networks`, {
    networks: []
  }).to(vm.packages = []).then(() => {
    vm.packages.sort(ascBy(lowerCaseProperty('name')))
    vm.packages = [{ id: 'ALL', name: 'All Organizations' }].concat(vm.packages)
  })

  $scope.$watch('vm.reportPeriod', (type) => {
    vm.selectReportPeriod(type)
  })

  /**
   * Select interval by Report Date
   *
   */
  vm.selectReportPeriod = () => {
    const from = new Date()
    const to = new Date()

    vm.report.periodCount = vm.reportDates[vm.reportPeriod]?.periodCount
    vm.report.periodType = vm.reportDates[vm.reportPeriod]?.periodType

    if (vm.reportPeriod === 'CUSTOM') {
      vm.report.from = from
      vm.report.to = to
    } else {
      vm.report.from = null
      vm.report.to = null
    }
  }

  // cache default handler for datepicker
  const changeHandlerFrom = (form) => {
    form.dateFrom.$setTouched()
    const fromActual = new Date(vm.report.from?.setHours(0, 0, 1, 0))
    const toActual = new Date(vm.report.to?.setHours(23, 59, 59, 999))
    const minError = vm.dpCfgFrom.minDate > fromActual
    const maxError = vm.dpCfgFrom.maxDate < fromActual
    form.dateFrom.$setValidity('min', !minError)
    form.dateFrom.$setValidity('max', !maxError)
    const afterError = toActual < fromActual
    if (afterError) {
      form.dateFrom.$setValidity('after', false)
    } else {
      if (form.dateFrom.$modelValue) {
        form.dateFrom.$setValidity('after', true)
      }
    }
    if (form.dateFrom.$valid) {
      form.dateTo.$setValidity('earlier', true)
    }
  }

  /**
   * Datepicker default settings
   *
   * @memberof mwApp/reports.controller:AddTransactionReportCtrl
   * @type {{format : string}}
   */
  vm.dpCfgFrom = {
    format: 'dd.MM.yyyy',
    minDate: moment().subtract(0, 'day').startOf('day').subtract(3, 'year').add(1, 'seconds').toDate(),
    maxDate: moment().startOf('day').add(1, 'seconds').toDate(),
    changeHandler: changeHandlerFrom
  }

  /**
   * Handle open "from" datepicker
   *
   * @memberof mwApp/reports.controller:AddTransactionReportCtrl
   */
  vm.openFrom = function () {
    vm.dpCfgFrom.openedFrom = true
  }

  // cache default handler for datepicker
  const changeHandlerTo = (form) => {
    form.dateTo.$setTouched()
    const fromActual = new Date(vm.report.from?.setHours(0, 0, 0, 0))
    const toActual = new Date(vm.report.to?.setHours(23, 59, 59, 999))
    const minError = vm.dpCfgTo.minDate > toActual
    const maxError = vm.dpCfgTo.maxDate < toActual
    form.dateTo.$setValidity('min', !minError)
    form.dateTo.$setValidity('max', !maxError)
    const earlierError = toActual < fromActual
    if (earlierError) {
      form.dateTo.$setValidity('earlier', false)
    } else {
      if (form.dateTo.$modelValue) {
        form.dateTo.$setValidity('earlier', true)
      }
    }
    if (form.dateTo.$valid) {
      form.dateFrom.$setValidity('after', true)
    }
  }

  /**
   * Datepicker default settings
   *
   * @memberof mwApp/reports.controller:AddTransactionReportCtrl
   * @type {{format : string}}
   */
  vm.dpCfgTo = {
    format: 'dd.MM.yyyy',
    minDate: moment().subtract(1, 'day').endOf('day').subtract(3, 'year').add(1, 'seconds').toDate(),
    maxDate: moment().endOf('day').toDate(),
    changeHandler: changeHandlerTo
  }

  /**
   * Handle open "to" datepicker
   *
   * @memberof mwApp/reports.controller:AddTransactionReportCtrl
   */
  vm.openTo = function () {
    vm.dpCfgTo.openedTo = true
  }

  vm.loadSubscriptions = function () {
    const networkIds = vm.report.organizations.map(i => i.id).join(',')

    return ReportFinancialSeed.loadExtra({ params: { networkIds } })
      .then(data => data.subscriptions)
      .then(subscriptions => {
        vm.subscriptionsFilter.length = 0
        vm.subscriptionsFilter = [].concat(subscriptions)
        vm.subscriptionsFilterNames = vm.subscriptionsFilter.map(i => i.name)
        vm.filterSubscriptions()
      })
      .catch(rejection => alertLiteSvc.alertError(rejection))
      .finally(vm.unsetDisable)
  }

  vm.getOrganizationsDebounced = _.debounce(vm.loadSubscriptions, 1500)

  vm.onOrganizationsChange = function () {
    vm.multiSelectWithAll(vm.report.organizations, vm.organizationsSelect)
    vm.setDisable()
    vm.getOrganizationsDebounced()
  }

  vm.deselectOrganizations = function () {
    vm.setDisable()
    vm.getOrganizationsDebounced()
  }
  vm.filterSubscriptions = function () {
    vm.report.subscriptionsFilter.names = vm.report.subscriptionsFilter.names?.filter(name => vm.subscriptionsFilterNames.includes(name))
  }

  /**
   * Filter users, it seems that this works faster, then filter in ui-select-choices
   *
   * @memberof mwApp/shows.controller:AddTransactionReportCtrl
   * @param  {Object} $select
   */
  vm.$timerUsers = 0
  vm.openCountUsers = 0
  vm.refreshUsers = function ($select = {}) {
    let search = $select.search || ''

    vm.searchUsersParams.page = 0

    search = search ? search.toLowerCase() : ''
    vm.openCountUsers = $select.open ? vm.openCountUsers + 1 : 0

    if (vm.openCountUsers > 1) {
      vm.searchUsersParams.searchStr = $select.search
    }

    if (vm.openCountUsers === 1) {
      $select.search = vm.searchUsersParams.searchStr
    }

    if ($select.open) {
      window.clearTimeout(vm.$timerUsers)
      vm.$timerUsers = window.setTimeout(() => {
        ReportFinancialSeed.search(
          `api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/extra/users`,
          {
            searchStr: search,
            page: 0,
            networkIds: vm.report.organizations?.map((n) => n.id).filter(n => n !== null) || []
          }
        )
          .then((result) => {
            vm.searchUsersParams.totalPages = result.totalPages
            vm.users = result.content || []
          })
      }, 700)
    }
  }

  /**
   * Tag transformer for custom select value
   *
   * @param newTag
   * @return {{id : null, email : *}}
   */
  vm.tagTransform = function (newTag) {
    return {
      id: null,
      email: newTag
    }
  }

  vm.$timerUsersScroll = 0
  vm.usersCallbackScroll = (event) => {
    const { page, totalPages } = vm.searchUsersParams
    if (page <= totalPages && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerUsersScroll)
      vm.$timerUsersScroll = window.setTimeout(() => {
        ReportFinancialSeed.search(
          `api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/extra/users`,
          { ...vm.searchUsersParams, page: page + 1 }
        )
          .then((result) => {
            vm.users = vm.users.concat(result.content)
            vm.searchUsersParams.page = result.number
          })
      }, 700)
    }
  }

  ReportFinancialSeed.search(
    `api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/extra/users`,
    vm.searchUsersParams
  )
    .then((result) => {
      vm.searchUsersParams.totalPages = result.totalPages
      return result.content || []
    })
    .to(vm.users = [])

  vm.generateReport = function () {
    vm.setDisable()
    vm.report
      ._save(null, 'api/report/transactional', 'Transactional Report generated')
      .data()
      .then(function (response) {
        const id = response.payload.id
        $location.hash('generated_reports')

        commonData.data.update('lastReport', id)

        vm.location.reload()
      })
      .finally(vm.unsetDisable)
  }

  vm.onPaymentSystemTypesChange = function () {
    const arr = []
    vm.report.paymentSystemTypes.forEach(type => (arr.push(...extra.paymentSystem2PaymentMethods[type])))
    vm.paymentMethodTypes = arr.filter((it, index) => index === arr.indexOf(it = it.trim()))
    vm.report.paymentMethodTypes = vm.report.paymentMethodTypes.filter(i => vm.paymentMethodTypes.includes(i))
  }

  ReportFinancialSeed.load(`api/reports/users/${vm.users_reporting_url.ACTIVATIONS}/extra/paymenttypes`, {
    paymentSystemTypes: []
  })
    .to(vm.paymentSystemTypes = [])
    .then(() => {
      vm.paymentSystemTypes = vm.paymentSystemTypes.filter(p => !['NEWEBPAY', 'TELR'].includes(p))
        .map(type => ({ type, name: vm.payment_system_types[type] }))
    })

  vm.organizationsSelect.val = { id: 'ALL', name: 'All Organizations' }
}
